
import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { PlantUpgradeStatusService, PlantUpgradeStatusServiceData, PlantUpgradeStatus } from '@plants';
import { SerializedPollService } from 'modules/tools-module/serialized-poll.service';



@Injectable()
export class BatchUpgradeStatusService implements PlantUpgradeStatusService{

    constructor(){
        this.setData()
        this.poller.start();
    }

    public pollingTime : number = 5000;

    private poller: SerializedPollService = new SerializedPollService(async() => {
        await this.setData();
    }, this.pollingTime)

    public subject: Subject<PlantUpgradeStatusServiceData> = new Subject();

    public onData : Observable<PlantUpgradeStatusServiceData> = this.subject.asObservable();

    public async setData(){
        this.subject.next({
            '5cddab71-625f-4183-9896-de9ae6effec9' : {
                status : PlantUpgradeStatus.scheduled
            },
            '747e12f7-0005-4e41-8873-0af577d44554' : {
                status : PlantUpgradeStatus.succeeded
            },
            '7d85dbd8-329f-4d70-aabe-f68bfd7858f3' : {
                status : PlantUpgradeStatus.failed,
                message : 'An Error occurred! (500)'
            },
            '45713d1f-a48c-45ca-b2e4-8dc0f754ebcb' : {
                status : PlantUpgradeStatus.running
            },
            '62693484-84f7-4796-b513-94b17cc9138d' : {
                status : PlantUpgradeStatus.timedout
            }
        })
    }

}